"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useResolutionCheck2 = _interopRequireDefault(require("./useResolutionCheck"));
var _NotifyIcon = _interopRequireDefault(require("./NotifyIcon"));
var _excluded = ["iconName", "buttonText"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledIconButton = (0, _styledComponents["default"])(_material.Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.MuiButton-root {\n    min-width: 45px;\n    min-height: 45px;\n    padding: 7px !important;\n  }\n"])));
var ResponsiveIconButton = function ResponsiveIconButton(_ref) {
  var iconName = _ref.iconName,
    buttonText = _ref.buttonText,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useResolutionCheck = (0, _useResolutionCheck2["default"])(),
    isDesktop = _useResolutionCheck.isDesktop;
  return isDesktop ? /*#__PURE__*/_react["default"].createElement(_material.Button, _extends({
    startIcon: /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
      iconName: iconName
    })
  }, props), buttonText) : /*#__PURE__*/_react["default"].createElement(StyledIconButton, props, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    iconName: iconName
  }));
};
ResponsiveIconButton.propTypes = {
  iconName: _propTypes["default"].string.isRequired,
  buttonText: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = ResponsiveIconButton;